import React, { FC } from 'react';
import { FilterButton } from 'components';
import { StyledHeaderExtra } from './styles';

interface HeaderExtraProps {
  isFilterActive: boolean;
  onFilterOpen: () => void;
  onFilterClose: () => void;
}

export const HeaderExtra: FC<HeaderExtraProps> = ({ isFilterActive, onFilterOpen, onFilterClose }) => {
  return (
    <StyledHeaderExtra>
      <FilterButton isFilterActive={isFilterActive} onOpen={onFilterOpen} onClose={onFilterClose} />
    </StyledHeaderExtra>
  );
};
